import { PaymentMethod } from '@/models/PaymentMethod';
import { delay } from '@/utils/async';

const DEFAULT_RETRY_DELAYS_MS = [250, 500, 1000, 2000, 3000, 3000];

export class DefaultPaymentMethodPendingError extends Error {
  constructor() {
    super('The payment method is still being processed.');
    this.name = 'DefaultPaymentMethodPendingError';
  }
}

interface WaitForDefaultPaymentMethodOptions {
  retryDelaysMs?: number[];
  wait?: (milliseconds: number) => Promise<void>;
}

export async function waitForDefaultPaymentMethod(
  getDefaultPaymentMethod: () => Promise<PaymentMethod | undefined>,
  options: WaitForDefaultPaymentMethodOptions = {},
): Promise<PaymentMethod> {
  const retryDelaysMs = options.retryDelaysMs ?? DEFAULT_RETRY_DELAYS_MS;
  const wait = options.wait ?? delay;

  for (let attempt = 0; ; attempt += 1) {
    const paymentMethod = await getDefaultPaymentMethod();
    if (paymentMethod) {
      return paymentMethod;
    }

    const retryDelay = retryDelaysMs[attempt];
    if (retryDelay === undefined) {
      throw new DefaultPaymentMethodPendingError();
    }

    await wait(retryDelay);
  }
}
